/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UserSquareIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABJUlEQVR4nN2VuU7EQAyGt0JASwNLBTXiFaAm8REkYwuEtuMRCC1QEJ4Q0XPUS7cVyNldipyaHAWMZGk0/sef7dHIk8m/WSKygazPQPqBbN9dDFjfkS3zWCWAO7oGxrJlJUCfzLFoZJ9VFdSXTrYAsltEm7oBaepnTXcCAZpWVJwOBkiSq72i/kxkdzAAok2L+iiS/VFbhKx3AwJskfd8rEfGDhYA0DmQ3UfJxdHJbLbp5ntkewC2r34A0hcAOSiJ1w99fnnomo4AnTcFXy/XVFXSCvC2tAX/hZA+BgO8z/ll1pvawCsfgB0HA0Rka5mdvdZnvvTFcbwd/gZoCZGe+p75eqeo9zP35Rq0pBWwGhZD/YO3UQcOkD3VjEzL+lQCTSPzz64fyQ5yCmjapKUAAAAASUVORK5CYII=)
 */
export const UserSquareIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M5 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5Zm10 6a3 3 0 1 1-6 0 3 3 0 0 1 6 0Zm-9 9.83A5.83 5.83 0 0 1 11.83 12h.34A5.83 5.83 0 0 1 18 17.83c0 .65-.52 1.17-1.17 1.17h-.08a.52.52 0 0 1-.5-.4c-.22-.87-.54-1.69-.83-2.3-.1-.23-.42-.15-.42.1v2.1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-2.1c0-.25-.31-.33-.42-.1-.3.61-.61 1.43-.83 2.3a.52.52 0 0 1-.5.4h-.08C6.52 19 6 18.48 6 17.83Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
